/*
 * @Author: lsq
 * @Date: 2023-11-28 14:12:34
 * @LastEditTime: 2025-09-02 15:27:15
 * @LastEditors: lsq
 * @Description: 
 * @FilePath: /sunpay-web/src/utils/validate.js
 */
const Regulars = {
  phoneNumber: /^1[0-9]{10}$/,
  number: /^(?:[1-9]\d*)$/,
  password:
    /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/,


}

export default Regulars
